import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=45d08516"
import script from "./UploadModal.js?vue&type=script&lang=js&external"
export * from "./UploadModal.js?vue&type=script&lang=js&external"
import style0 from "./UploadModal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports